export enum AuthOperationKind {
  LOGIN = 'login',
  RESET = 'reset',
}
